import utils from '../utils/utils'
import globalVar from '../utils/globalVar'
import { animate, stagger } from 'animejs'

class Home {
  constructor() {
    let cache = {};

    let initFunc = () => {
      initCache();
      registerEvents();
    };

    let initCache = () => {
      cache.page             = document.querySelector('.template-home');
      cache.sliderEl         = document.querySelector('.js-interventions-slider');
      cache.decisionsEl      = document.querySelector('.js-decisions-slider');
      cache.interventionsEl  = document.querySelector('.section-interventions');
    };

    let registerEvents = () => {
      if (cache.sliderEl) {
        initInterventionsSlider(cache.sliderEl);
      }
      if (cache.decisionsEl) {
        initDecisionsSlider(cache.decisionsEl);
      }
      if (cache.interventionsEl) {
        initInterventionsAnim(cache.interventionsEl);
      }
    };

    // ── Slider interventions ─────────────────────────────────
    let initInterventionsSlider = (el) => {
      const slides        = Array.from(el.querySelectorAll('.section-interventions__slide'));
      const currentNumEl  = el.querySelector('.js-slider-current');
      const othersEl      = el.querySelector('.js-slider-others');
      const prevBtn       = el.querySelector('.js-slider-prev');
      const nextBtn       = el.querySelector('.js-slider-next');
      const total         = slides.length;
      let current         = 0;

      // Pré-génère tous les numéros "autres" (indices 1 à total-1)
      // Slide 0 (index 0) n'est jamais dans la liste (elle devient le grand numéro)
      const initOthers = () => {
        othersEl.innerHTML = '';
        for (let i = 1; i < total; i++) {
          const span = document.createElement('span');
          span.className = 'section-interventions__nav-other-num';
          span.textContent = i + 1;
          span.dataset.index = i;
          span.addEventListener('click', () => goTo(i));
          othersEl.appendChild(span);
        }
      };

      // Affiche l'état courant : numéro actif, autres numéros, flèches, slide active
      const render = () => {
        // Grand numéro courant
        currentNumEl.textContent = current + 1;

        // Fade out les numéros déjà atteints (idx <= current), fade in les suivants
        othersEl.querySelectorAll('.section-interventions__nav-other-num').forEach((span) => {
          const idx = parseInt(span.dataset.index, 10);
          span.classList.toggle('is-hidden', idx <= current);
        });

        // Flèches : masquée si on est au début / à la fin
        prevBtn.classList.toggle('is-hidden', current === 0);
        nextBtn.classList.toggle('is-hidden', current === total - 1);

        // Slide active (fade via CSS)
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
        });
      };

      const goTo = (index) => {
        if (index < 0 || index >= total || index === current) return;
        current = index;
        render();
      };

      // Événements flèches
      prevBtn.addEventListener('click', () => goTo(current - 1));
      nextBtn.addEventListener('click', () => goTo(current + 1));

      // Initialisation
      initOthers();
      render();
    };

    // ── Animation interventions au scroll ────────────────────
    let initInterventionsAnim = (section) => {
      const panel   = section.querySelector('.section-interventions__panel');
      const current = section.querySelector('.section-interventions__nav-current');

      section.classList.add('will-animate');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          observer.disconnect();

          // 1. Panel
          animate(panel, {
            opacity:    [0, 1],
            translateY: [40, 0],
            duration:   700,
            ease:       'outCubic',
          });

          // 2. Numéros en stagger (current + others, générés après initOthers)
          const nums = [current, ...Array.from(section.querySelectorAll('.section-interventions__nav-other-num'))];
          animate(nums, {
            opacity:    [0, 1],
            translateY: [12, 0],
            duration:   700,
            delay:      stagger(80, { start: 250 }),
            ease:       'outCubic',
          });
        });
      }, { threshold: 0.25 });

      observer.observe(section);
    };

    // ── Slider decisions (mobile uniquement) ─────────────────
    let initDecisionsSlider = (el) => {
      const items   = Array.from(el.querySelectorAll('.section-decisions__item'));
      const prevBtn = el.querySelector('.js-decisions-prev');
      const nextBtn = el.querySelector('.js-decisions-next');
      const total   = items.length;
      let current   = 0;

      const render = () => {
        prevBtn.classList.toggle('is-hidden', current === 0);
        nextBtn.classList.toggle('is-hidden', current === total - 1);
        items.forEach((item, i) => {
          item.classList.toggle('is-active', i === current);
        });
      };

      prevBtn.addEventListener('click', () => {
        if (current > 0) { current--; render(); }
      });
      nextBtn.addEventListener('click', () => {
        if (current < total - 1) { current++; render(); }
      });

      render();
    };

    initFunc();
  }
}

export { Home };
